// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mds-header .container h2 {
    color: red
}

.wrapper {
	width: 100%;
	position: relative;
}
/* :root {
  --color-primary-orange: #f28f34;
} */

.topbar {
	position: fixed;
	top: 0;
	left: 270px;
	right: 0;
	height: 45px;
	background: var(--color-primary-orange);
	/* border-bottom: 1px solid rgb(228 228 228 / 0%); */
	z-index: 150;
 box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 0px 6px 0 rgb(206 206 238 / 54%);
	transition: left 0.3s ease;
}

.topbar .navbar {
	width: 100%;
	height: 45px;
	padding-left: 30px;
	padding-right: 30px;
	justify-content: flex-end;
}

.topbar .navbar .navbar-nav .nav-link {
	padding-right: .8rem;
	padding-left: .8rem;
	color: var(--color-text-dark);
	font-size: 22px
}

.user-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 55px;
    border-left: 0px solid var(--color-border-light);
    margin-left: 1rem;
    margin-right: -1rem;
    padding-left: 0;
}

.user-img {
	width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 0 solid #e5e5e5;
    padding: 0;
    font-size: 32px;
    color: var(--color-icon-muted);
}

.user-info .user-name {
	font-size: 15px;
	font-weight: 500;
	color: var(--color-white)
}

.user-info .designattion {
	font-size: 13px;
	color: var(--color-white)
}

.user-box .dropdown-menu i {
	vertical-align: middle;
	margin-right: 10px
}

.dropdown-menu {
	box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);
	border: 0 solid var(--color-border-light);
	border-radius: 10px;
	font-size: 14px
}

.dropdown-toggle-nocaret:after {
	display: none
}

.topbar .navbar .dropdown-large .dropdown-menu::after {
	content: '';
	width: 13px;
	height: 13px;
	background: var(--color-white);
	position: absolute;
	top: -6px;
	right: 16px;
	transform: rotate(45deg);
	border-top: 1px solid #ddd;
	border-left: 1px solid #ddd
}

.topbar .navbar .dropdown-menu::after {
	content: '';
	width: 13px;
	height: 13px;
	background: var(--color-white);
	position: absolute;
	top: -6px;
	right: 16px;
	transform: rotate(45deg);
	border-top: 1px solid #ddd;
	border-left: 1px solid #ddd
}

.topbar .navbar .dropdown-menu {
	animation: .6s cubic-bezier(.25, .8, .25, 1) 0s normal forwards 1 animdropdown
}
.designation-icon {
    color: var(--color-icon-muted);
    font-size: 15px;
    width: 20px;
    flex-shrink: 0;
    text-align: center;
    margin-top: 2px;
    margin-left: 15px;
}

.designation-text {
    font-size: 14px;
    color: var(--color-text-dark);
    line-height: 1.4;
}

.company-select-box {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 38px;
    padding: 8px 14px;
    background: var(--color-white);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.company-selected-text {
    color: var(--color-text-dark);
    font-size: 14px;
    flex: 1 1;
    padding-left: 8px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
}

.company-arrow {
    margin-top: 2px;
}

/* .company-arrow {
    color: #6c757d;
    font-size: 9px;
    margin-left: auto;
} */

.custom-company-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: var(--color-bg-panel);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
    list-style: none;
    margin: 0;
    padding: 6px 0;
    z-index: 20;
    max-height: 220px;
    overflow-y: auto;
}

.custom-company-dropdown li {
    padding: 10px 14px;
    color: var(--color-text-dark);
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.custom-company-dropdown li:hover {
    background: rgba(0, 0, 0, 0.05);
}

.custom-company-dropdown li.active {
    color: var(--color-primary-orange);
    font-weight: 600;
}
.topbar .navbar .dropdown-menu {
    background: var(--color-bg-panel);
	border: 1px solid rgba(0, 0, 0, 0.08);
    min-width: 260px;
    border-radius: 14px;
    overflow: visible;
}

.dropdown-user-img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--color-white);
    color: var(--color-primary-green);
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.dropdown-user-info .user-name {
    font-size: 15px;
    /* font-weight: 600; */
    color: var(--color-text-dark);
}

.dropdown-user-info .designattion {
    font-size: 13px;
    color: var(--color-text-dark);
}
.topbar .navbar .dropdown-menu::after {
    border-radius: 2px;
}
.topbar .navbar .dropdown-menu .dropdown-item {
    color: var(--color-text-dark) !important;
    opacity: 1 !important;
    background: transparent !important;
	padding: 4px 14px !important;
}

.topbar .navbar .dropdown-menu .dropdown-item:hover {
    background: transparent !important;
    color: #7f8991 !important;
}
.company-select-box .company-select option {
    background: var(--color-bg-panel);
    color: var(--color-text-dark);
    font-size: 14px;
    font-family: inherit;
    padding: 8px 12px;
}

.company-select-box .company-select option:checked,
.company-select-box .company-select option:hover {
    background: var(--color-primary-orange);
    color: var(--color-white);
}
.topbar .navbar .dropdown-menu .dropdown-divider {
    margin: 0 !important;
}

.mobile-portal-toggle {
	display: none;
}

@media (max-width: 768px) {
	.topbar .navbar > div[style*="display: flex"] > .portal-toggle-container,
	.topbar .navbar .portal-toggle-container {
		display: none !important;
	}

	.ticketing-link {
		display: none !important;
	}

	.mobile-portal-toggle {
		display: flex !important;
	}
    .user-info {
		padding-right: 18px;
	}
}
@media (max-width: 768px) {
  .ticketing-link {
    display: none !important;
  }
}
.mobile-quick-links {
    display: none;
}

@media (max-width: 768px) {
    .mobile-quick-links {
        display: block;
    }
}

.mobile-quick-link-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    color: var(--color-text-dark);
    font-size: 14px;
    cursor: pointer;
    margin-left: 10px;
}

.mobile-quick-link-item:hover {
    color:var(--color-primary-orange);
}

.mobile-quick-link-item i {
    color:var(--color-primary-orange);
    width: 20px;
}
@media (max-width: 768px) {
    .topbar {
    height: 45px;
  }
  .topbar .navbar {
    height: 45px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .toggle-menu {
    height: 56px;
    padding: 0 10px !important;
    font-size: 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  
  .company-logo {
    width: 32px !important;
    height: 45px !important;
    padding: 0 !important;
    margin: 0 !important;
    object-fit: contain;
    display: block;
  }
  .user-info {
    padding-left: 1px !important;
    padding-right: 1px !important;
    color: var(--color-primary-green) !important;
    /* background-color: var(--color-primary-green) !important; */
  }

  .dropdown-user-img {
    width: 28px !important;
    height: 28px !important;
    font-size: 18px !important;
     margin-left: -10px;
  }
  
}
.dropdown-item-icon {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 10px;
}

.dropdown-item-icon i {
    width: 20px;
    text-align: center;
    color:var(--color-primary-green);
    flex-shrink: 0;
    
}
.dropdown-icon-self {
    width: 10px;
    text-align: center;
    color: var(--color-primary-green);
    flex-shrink: 0;
    
}
.quick-apps-trigger {
    height: 32px;
    width: 32px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--color-white);
    font-size: 15px;
}

.quick-apps-trigger:hover {
    background: rgba(255, 255, 255, 0.4);
}

.quick-apps-panel {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background: var(--color-white);
    border-radius: 14px;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);
    padding: 16px;
    display: flex;
    gap: 20px;
    z-index: 200;
}

.quick-apps-panel::after {
    content: '';
    position: absolute;
    top: -6px;
    right: 16px;
    width: 13px;
    height: 13px;
    background: var(--color-white);
    transform: rotate(45deg);
    box-shadow: -2px -2px 3px -1px rgba(0, 0, 0, 0.06);
}

.quick-app-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    width: 70px;
}

.quick-app-item span {
    font-size: 12px;
    color: var(--color-text-dark);
    text-align: center;
    line-height: 1.3;
}

.quick-app-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-white);
    font-size: 20px;
}

.quick-app-icon-red { background: #e0435c; }
.quick-app-icon-teal { background: #14a89d; }

.quick-links-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--color-primary-orange);
    color: var(--color-white);
    font-size: 0.8rem;
    font-weight: 600;
    padding: 6px 14px;
    border-radius: 20px;
    cursor: pointer;
    border: 1px solid var(--color-primary-green);
    transition: background 0.2s ease, border-color 0.2s ease;
}

.quick-links-trigger:hover {
    background: var(--color-primary-green);
    border-color: var(--color-primary-green);
}

.quick-links-trigger-active {
    background: var(--color-primary-green) !important;
    border-color: var(--color-primary-green) !important;
}

.quick-links-chevron {
    font-size: 11px;
    transition: transform 0.2s ease;
}

.quick-links-chevron-open {
    transform: rotate(180deg);
}

.quick-links-panel {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background: var(--color-white);
    border-radius: 14px;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);
    padding: 6px 0;
    display: flex;
    flex-direction: column;
    gap: 0;
    z-index: 200;
}

.quick-link-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 16px;
    cursor: pointer;
    border-bottom: 1px solid #eef0f2;
    transition: background 0.2s ease;
    white-space: nowrap;
}

.quick-link-card:last-child {
    border-bottom: none;
}

.quick-link-card:hover {
    background: var(--color-bg-hover);
}

.quick-link-card-icon {
    font-size: 14px;
    color: var(--color-primary-orange);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.quick-link-divider {
    width: 1px;
    height: 18px;
    background: rgba(255, 255, 255, 0.3);
}
.portal-toggle-container-mobile {
    display: inline-flex;
    width: 100%;
    background: var(--color-white);
    border-radius: 20px;
    padding: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--color-border-light);
}

.portal-toggle-btn {
    flex: 1 1;
    cursor: pointer;
    font-weight: 500;
    font-size: 13px;
    padding: 6px 16px;
    border-radius: 16px;
    border: none;
    transition: all 0.3s ease;
    white-space: nowrap;
    background: transparent;
    color: #666666;
}

.portal-toggle-btn-active {
    background: var(--color-primary-green);
    color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/containers/header/Header.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;;GAEG;;AAEH;CACC,eAAe;CACf,MAAM;CACN,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,uCAAuC;CACvC,oDAAoD;CACpD,YAAY;CAET,kFAAkF;CACrF,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,6BAA6B;CAC7B;AACD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gDAAgD;IAChD,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,8BAA8B;AAClC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CAEC,2CAA2C;CAC3C,yCAAyC;CACzC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,8BAA8B;CAC9B,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,wBAAwB;CACxB,0BAA0B;CAC1B;AACD;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,8BAA8B;CAC9B,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,wBAAwB;CACxB,0BAA0B;CAC1B;AACD;;AAEA;CAEC;AACD;AACA;IACI,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,SAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;GAIG;;AAEH;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iCAAiC;IACjC,qCAAqC;IACrC,mBAAmB;IACnB,4CAA4C;IAC5C,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,iCAAiC;CACpC,qCAAqC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,qBAAqB;IACrB,kCAAkC;CACrC,4BAA4B;AAC7B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;AACA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;IAEI,uCAAuC;IACvC,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;IACG;EACF,mBAAmB;CACpB;AACD;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,WAAW;AACf;AACA;IACI;IACA,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,0BAA0B;IAC1B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;;EAGA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,4CAA4C;IAC5C,6DAA6D;EAC/D;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;KACzB,kBAAkB;EACrB;;AAEF;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;;AAElB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;;AAElB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa;IACb,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,wBAAwB;IACxB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;AACnB;;AAEA,sBAAsB,mBAAmB,EAAE;AAC3C,uBAAuB,mBAAmB,EAAE;;AAE5C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uCAAuC;IACvC,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,4CAA4C;IAC5C,wDAAwD;AAC5D;;AAEA;IACI,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,iDAAiD;IACjD,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,+CAA+C;IAC/C,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,oBAAoB;IACpB,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;AAC7B","sourcesContent":[".mds-header .container h2 {\r\n    color: red\r\n}\r\n\r\n.wrapper {\r\n\twidth: 100%;\r\n\tposition: relative;\r\n}\r\n/* :root {\r\n  --color-primary-orange: #f28f34;\r\n} */\r\n\r\n.topbar {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 270px;\r\n\tright: 0;\r\n\theight: 45px;\r\n\tbackground: var(--color-primary-orange);\r\n\t/* border-bottom: 1px solid rgb(228 228 228 / 0%); */\r\n\tz-index: 150;\r\n\t-webkit-box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 0px 6px 0 rgb(206 206 238 / 54%);\r\n    box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 0px 6px 0 rgb(206 206 238 / 54%);\r\n\ttransition: left 0.3s ease;\r\n}\r\n\r\n.topbar .navbar {\r\n\twidth: 100%;\r\n\theight: 45px;\r\n\tpadding-left: 30px;\r\n\tpadding-right: 30px;\r\n\tjustify-content: flex-end;\r\n}\r\n\r\n.topbar .navbar .navbar-nav .nav-link {\r\n\tpadding-right: .8rem;\r\n\tpadding-left: .8rem;\r\n\tcolor: var(--color-text-dark);\r\n\tfont-size: 22px\r\n}\r\n\r\n.user-box {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 45px;\r\n    width: 55px;\r\n    border-left: 0px solid var(--color-border-light);\r\n    margin-left: 1rem;\r\n    margin-right: -1rem;\r\n    padding-left: 0;\r\n}\r\n\r\n.user-img {\r\n\twidth: 38px;\r\n    height: 38px;\r\n    border-radius: 50%;\r\n    border: 0 solid #e5e5e5;\r\n    padding: 0;\r\n    font-size: 32px;\r\n    color: var(--color-icon-muted);\r\n}\r\n\r\n.user-info .user-name {\r\n\tfont-size: 15px;\r\n\tfont-weight: 500;\r\n\tcolor: var(--color-white)\r\n}\r\n\r\n.user-info .designattion {\r\n\tfont-size: 13px;\r\n\tcolor: var(--color-white)\r\n}\r\n\r\n.user-box .dropdown-menu i {\r\n\tvertical-align: middle;\r\n\tmargin-right: 10px\r\n}\r\n\r\n.dropdown-menu {\r\n\t-webkit-box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);\r\n\tbox-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);\r\n\tborder: 0 solid var(--color-border-light);\r\n\tborder-radius: 10px;\r\n\tfont-size: 14px\r\n}\r\n\r\n.dropdown-toggle-nocaret:after {\r\n\tdisplay: none\r\n}\r\n\r\n.topbar .navbar .dropdown-large .dropdown-menu::after {\r\n\tcontent: '';\r\n\twidth: 13px;\r\n\theight: 13px;\r\n\tbackground: var(--color-white);\r\n\tposition: absolute;\r\n\ttop: -6px;\r\n\tright: 16px;\r\n\ttransform: rotate(45deg);\r\n\tborder-top: 1px solid #ddd;\r\n\tborder-left: 1px solid #ddd\r\n}\r\n\r\n.topbar .navbar .dropdown-menu::after {\r\n\tcontent: '';\r\n\twidth: 13px;\r\n\theight: 13px;\r\n\tbackground: var(--color-white);\r\n\tposition: absolute;\r\n\ttop: -6px;\r\n\tright: 16px;\r\n\ttransform: rotate(45deg);\r\n\tborder-top: 1px solid #ddd;\r\n\tborder-left: 1px solid #ddd\r\n}\r\n\r\n.topbar .navbar .dropdown-menu {\r\n\t-webkit-animation: .6s cubic-bezier(.25, .8, .25, 1) 0s normal forwards 1 animdropdown;\r\n\tanimation: .6s cubic-bezier(.25, .8, .25, 1) 0s normal forwards 1 animdropdown\r\n}\r\n.designation-icon {\r\n    color: var(--color-icon-muted);\r\n    font-size: 15px;\r\n    width: 20px;\r\n    flex-shrink: 0;\r\n    text-align: center;\r\n    margin-top: 2px;\r\n    margin-left: 15px;\r\n}\r\n\r\n.designation-text {\r\n    font-size: 14px;\r\n    color: var(--color-text-dark);\r\n    line-height: 1.4;\r\n}\r\n\r\n.company-select-box {\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    min-height: 38px;\r\n    padding: 8px 14px;\r\n    background: var(--color-white);\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n    border-radius: 8px;\r\n}\r\n\r\n.company-selected-text {\r\n    color: var(--color-text-dark);\r\n    font-size: 14px;\r\n    flex: 1;\r\n    padding-left: 8px;\r\n    white-space: normal;\r\n    word-break: break-word;\r\n    line-height: 1.4;\r\n}\r\n\r\n.company-arrow {\r\n    margin-top: 2px;\r\n}\r\n\r\n/* .company-arrow {\r\n    color: #6c757d;\r\n    font-size: 9px;\r\n    margin-left: auto;\r\n} */\r\n\r\n.custom-company-dropdown {\r\n    position: absolute;\r\n    top: calc(100% + 6px);\r\n    left: 0;\r\n    right: 0;\r\n    background: var(--color-bg-panel);\r\n    border: 1px solid rgba(0, 0, 0, 0.08);\r\n    border-radius: 10px;\r\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 6px 0;\r\n    z-index: 20;\r\n    max-height: 220px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.custom-company-dropdown li {\r\n    padding: 10px 14px;\r\n    color: var(--color-text-dark);\r\n    font-size: 14px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.custom-company-dropdown li:hover {\r\n    background: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.custom-company-dropdown li.active {\r\n    color: var(--color-primary-orange);\r\n    font-weight: 600;\r\n}\r\n.topbar .navbar .dropdown-menu {\r\n    background: var(--color-bg-panel);\r\n\tborder: 1px solid rgba(0, 0, 0, 0.08);\r\n    min-width: 260px;\r\n    border-radius: 14px;\r\n    overflow: visible;\r\n}\r\n\r\n.dropdown-user-img {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    background: var(--color-white);\r\n    color: var(--color-primary-green);\r\n    font-size: 18px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0;\r\n}\r\n\r\n.dropdown-user-info .user-name {\r\n    font-size: 15px;\r\n    /* font-weight: 600; */\r\n    color: var(--color-text-dark);\r\n}\r\n\r\n.dropdown-user-info .designattion {\r\n    font-size: 13px;\r\n    color: var(--color-text-dark);\r\n}\r\n.topbar .navbar .dropdown-menu::after {\r\n    border-radius: 2px;\r\n}\r\n.topbar .navbar .dropdown-menu .dropdown-item {\r\n    color: var(--color-text-dark) !important;\r\n    opacity: 1 !important;\r\n    background: transparent !important;\r\n\tpadding: 4px 14px !important;\r\n}\r\n\r\n.topbar .navbar .dropdown-menu .dropdown-item:hover {\r\n    background: transparent !important;\r\n    color: #7f8991 !important;\r\n}\r\n.company-select-box .company-select option {\r\n    background: var(--color-bg-panel);\r\n    color: var(--color-text-dark);\r\n    font-size: 14px;\r\n    font-family: inherit;\r\n    padding: 8px 12px;\r\n}\r\n\r\n.company-select-box .company-select option:checked,\r\n.company-select-box .company-select option:hover {\r\n    background: var(--color-primary-orange);\r\n    color: var(--color-white);\r\n}\r\n.topbar .navbar .dropdown-menu .dropdown-divider {\r\n    margin: 0 !important;\r\n}\r\n\r\n.mobile-portal-toggle {\r\n\tdisplay: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.topbar .navbar > div[style*=\"display: flex\"] > .portal-toggle-container,\r\n\t.topbar .navbar .portal-toggle-container {\r\n\t\tdisplay: none !important;\r\n\t}\r\n\r\n\t.ticketing-link {\r\n\t\tdisplay: none !important;\r\n\t}\r\n\r\n\t.mobile-portal-toggle {\r\n\t\tdisplay: flex !important;\r\n\t}\r\n    .user-info {\r\n\t\tpadding-right: 18px;\r\n\t}\r\n}\r\n@media (max-width: 768px) {\r\n  .ticketing-link {\r\n    display: none !important;\r\n  }\r\n}\r\n.mobile-quick-links {\r\n    display: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .mobile-quick-links {\r\n        display: block;\r\n    }\r\n}\r\n\r\n.mobile-quick-link-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 8px 0;\r\n    color: var(--color-text-dark);\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n}\r\n\r\n.mobile-quick-link-item:hover {\r\n    color:var(--color-primary-orange);\r\n}\r\n\r\n.mobile-quick-link-item i {\r\n    color:var(--color-primary-orange);\r\n    width: 20px;\r\n}\r\n@media (max-width: 768px) {\r\n    .topbar {\r\n    height: 45px;\r\n  }\r\n  .topbar .navbar {\r\n    height: 45px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  .toggle-menu {\r\n    height: 56px;\r\n    padding: 0 10px !important;\r\n    font-size: 20px !important;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  \r\n  .company-logo {\r\n    width: 32px !important;\r\n    height: 45px !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    object-fit: contain;\r\n    display: block;\r\n  }\r\n  .user-info {\r\n    padding-left: 1px !important;\r\n    padding-right: 1px !important;\r\n    color: var(--color-primary-green) !important;\r\n    /* background-color: var(--color-primary-green) !important; */\r\n  }\r\n\r\n  .dropdown-user-img {\r\n    width: 28px !important;\r\n    height: 28px !important;\r\n    font-size: 18px !important;\r\n     margin-left: -10px;\r\n  }\r\n  \r\n}\r\n.dropdown-item-icon {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.dropdown-item-icon i {\r\n    width: 20px;\r\n    text-align: center;\r\n    color:var(--color-primary-green);\r\n    flex-shrink: 0;\r\n    \r\n}\r\n.dropdown-icon-self {\r\n    width: 10px;\r\n    text-align: center;\r\n    color: var(--color-primary-green);\r\n    flex-shrink: 0;\r\n    \r\n}\r\n.quick-apps-trigger {\r\n    height: 32px;\r\n    width: 32px;\r\n    border-radius: 8px;\r\n    background: rgba(255, 255, 255, 0.25);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    color: var(--color-white);\r\n    font-size: 15px;\r\n}\r\n\r\n.quick-apps-trigger:hover {\r\n    background: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.quick-apps-panel {\r\n    position: absolute;\r\n    top: calc(100% + 10px);\r\n    right: 0;\r\n    background: var(--color-white);\r\n    border-radius: 14px;\r\n    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);\r\n    padding: 16px;\r\n    display: flex;\r\n    gap: 20px;\r\n    z-index: 200;\r\n}\r\n\r\n.quick-apps-panel::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: -6px;\r\n    right: 16px;\r\n    width: 13px;\r\n    height: 13px;\r\n    background: var(--color-white);\r\n    transform: rotate(45deg);\r\n    box-shadow: -2px -2px 3px -1px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.quick-app-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 6px;\r\n    cursor: pointer;\r\n    width: 70px;\r\n}\r\n\r\n.quick-app-item span {\r\n    font-size: 12px;\r\n    color: var(--color-text-dark);\r\n    text-align: center;\r\n    line-height: 1.3;\r\n}\r\n\r\n.quick-app-icon {\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--color-white);\r\n    font-size: 20px;\r\n}\r\n\r\n.quick-app-icon-red { background: #e0435c; }\r\n.quick-app-icon-teal { background: #14a89d; }\r\n\r\n.quick-links-trigger {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: var(--color-primary-orange);\r\n    color: var(--color-white);\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n    padding: 6px 14px;\r\n    border-radius: 20px;\r\n    cursor: pointer;\r\n    border: 1px solid var(--color-primary-green);\r\n    transition: background 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.quick-links-trigger:hover {\r\n    background: var(--color-primary-green);\r\n    border-color: var(--color-primary-green);\r\n}\r\n\r\n.quick-links-trigger-active {\r\n    background: var(--color-primary-green) !important;\r\n    border-color: var(--color-primary-green) !important;\r\n}\r\n\r\n.quick-links-chevron {\r\n    font-size: 11px;\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.quick-links-chevron-open {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.quick-links-panel {\r\n    position: absolute;\r\n    top: calc(100% + 10px);\r\n    right: 0;\r\n    background: var(--color-white);\r\n    border-radius: 14px;\r\n    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);\r\n    padding: 6px 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0;\r\n    z-index: 200;\r\n}\r\n\r\n.quick-link-card {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 14px;\r\n    padding: 14px 16px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #eef0f2;\r\n    transition: background 0.2s ease;\r\n    white-space: nowrap;\r\n}\r\n\r\n.quick-link-card:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.quick-link-card:hover {\r\n    background: var(--color-bg-hover);\r\n}\r\n\r\n.quick-link-card-icon {\r\n    font-size: 14px;\r\n    color: var(--color-primary-orange);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.quick-link-divider {\r\n    width: 1px;\r\n    height: 18px;\r\n    background: rgba(255, 255, 255, 0.3);\r\n}\r\n.portal-toggle-container-mobile {\r\n    display: inline-flex;\r\n    width: 100%;\r\n    background: var(--color-white);\r\n    border-radius: 20px;\r\n    padding: 4px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    border: 1px solid var(--color-border-light);\r\n}\r\n\r\n.portal-toggle-btn {\r\n    flex: 1;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    font-size: 13px;\r\n    padding: 6px 16px;\r\n    border-radius: 16px;\r\n    border: none;\r\n    transition: all 0.3s ease;\r\n    white-space: nowrap;\r\n    background: transparent;\r\n    color: #666666;\r\n}\r\n\r\n.portal-toggle-btn-active {\r\n    background: var(--color-primary-green);\r\n    color: var(--color-white);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
